import React from 'react';
interface TrustBadgeProps {
  icon: React.ReactNode;
  text: string;
}
export const TrustBadge = ({
  icon,
  text
}: TrustBadgeProps) => {
  return <div className="flex flex-col items-center p-3" data-id="element-86">
      <div className="mb-2 text-gray-600" data-id="element-87">{icon}</div>
      <p className="text-xs text-center text-gray-700" data-id="element-88">{text}</p>
    </div>;
};